import config from '../../config'

export function getTemplatePath(vendor, shortcut) {
  return `${config.articleTemplateBasePath}/${shortcut}`
}
